import axios from "axios";
import { successHandling } from "../helpers/successHandling";

export const createUtilityAPI = async (
  utilityIds,
  companyIds,
  modelIds,
  note,
  t,
  successfulText
) => {
  await axios({
    url: `/api/v2/admin-utility/utility/create`,
    method: "POST",
    data: {
      note: note,
      company_ids: companyIds,
      device_model_ids: modelIds,
      firmware_ids: utilityIds
    }
  });
  successHandling(t, successfulText);
  return true;
};
